export type Breakpoint = 'initial' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const breakpoints: Record<Breakpoint, number> = {
  initial: 0,
  xs: 520,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1640,
};

export const breakpointKeys = Object.keys(breakpoints) as Breakpoint[];

/**
 * This function will return the media query string relative to the provided breakpoint
 * @param bp The breakpoint for the minimum width ( "xs" | "sm" | "md" | "lg" | "xl" )
 * @returns *@media only screen and (min-width: `breakpoint`)*
 */
export const getMediaQuery = (bp: Breakpoint): string => `
  @media only screen and (min-width: ${breakpoints[bp]}px)
`;

export const getMaxMediaQuery = (bp: Breakpoint): string => `
  @media only screen and (max-width: ${breakpoints[bp] - 1}px)
`;
